import Select from "react-select";
import React, { useEffect, useState } from "react";
import { ErrorMessage, Form, Formik } from "formik";
import PhoneInput from "react-phone-input-2";
import Mixpanel from "mixpanel-browser";
import { useDispatch, useSelector } from "react-redux";

import Fields from "../../form-components/Fields";
import addUserValidation from "../../../validations/userModuleValidation/addUserValidation";
import { getUserRoleList } from "../../../features/userManagement/getUserRolesSlice";
import { getProjectList } from "../../../features/projectManagement/getProjectListSlice";
import { addUser } from "../../../features/userManagement/addUserSlice";
import { getUserList } from "../../../features/userManagement/getUserListSlice";
// import { showSuccess } from "../../../utils/messageHelper";
import { CREATED } from "../../../constants/statusCode";
import axios from "axios";

const AddUserForm = ({ toggleFunction = () => { }, setCurrentActiveTab }) => {
  const [code, setCode] = useState("");
  const [codeMobile, setCodeMobile] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [mobile, setMobile] = useState("");

  const { userRoles, projectList } = useSelector((state) => ({
    userRoles: state?.getUserRoleListReducer?.responseData?.role,
    projectList: state?.getProjectListReducer?.responseData?.projects,
  }));
  let projectData = JSON.parse(localStorage.getItem("_user"));

  const dispatch = useDispatch();

  const userRoleOptions = [];
  userRoles &&
    userRoles.map((item) => {
      userRoleOptions.push({ label: item.name, value: item.uuid });
    });

  const userProjectOptions = [];
  projectList &&
    projectList.map((item) => {
      userProjectOptions.push({ label: item.name, value: item.uuid });
    });

  const getUserIp = async () => {
    const response = await axios.get("https://ipapi.co/json/");
    let { data } = response;
    setCode(data.country.toLowerCase());
  };

  useEffect(() => {
    getUserIp();
    dispatch(getUserRoleList({ perPage: 100, page: 1, search: "", is_active: 1, organisation_uuid: projectData?.organizations[0].uuid }));
    dispatch(getProjectList({ perPage: 100, page: 1, organization_uuid: projectData?.organizations[0].uuid }));
  }, []);

  const doSubmit = async (values, { resetForm }) => {
    const callBackFN = async () => {
      toggleFunction();
      resetForm();
      setCurrentActiveTab("pending");
      await dispatch(getUserList({ perPage: 10, page: 1, isActive: 0, organization_uuid: projectData?.organizations[0].uuid }));
    };

    const projects = [];
    const userRole = [];
    values?.project?.map((item) => projects.push(item.value));
    values?.userRole ? userRole.push(values?.userRole) : userRole.push(userRoleOptions[0].value);
    // userRole.push(values?.userRole)
    let formData = values;
    formData.project = projects;
    formData.roles = userRole;
    formData.isd_code = code;
    delete formData.userRole;
    formData.organization_uuid = projectData?.organizations[0]?.uuid;
    Mixpanel.track("Add user Button Clicked", {
      Page: "Add user Modal",
    });
    const { payload } = await dispatch(addUser(formData));
    if (payload.status === CREATED) {
      callBackFN();
      // showSuccess(payload.data.responseMessage);
    }
  };

  const mobileNumberHandler = (value, code) => {
    setCode(code?.dialCode);
    setCodeMobile(value);
    let number = value.substring(code?.dialCode?.length);
    setMobile(number);
    if (number && !(number.length > 7 && number.length < 12)) {
      setMobileError("Mobile number must be 8 to 11 digits.");
    } else {
      setMobileError("");
    }
  };

  const validate = (values) => {
    const errors = {};
    if (mobile) {
      values.mobile = mobile;
    }
    if (
      values.mobile &&
      !(values.mobile.length > 7 && values.mobile.length < 12)
    ) {
      errors.mobile = "Mobile number must be 8 to 11 digits.";
      setMobileError(errors.mobile);
    }
  };

  return (
    <>
      <div className="adduser-form">
        <Formik
          initialValues={{
            // toggleChecked: toggleChecked,
            first_name: "",
            last_name: "",
            email: "",
            userRole: "",
            mobile: codeMobile,
            isd_code: code,
            project: [],
          }}
          validate={validate}
          validationSchema={addUserValidation}
          onSubmit={doSubmit}
        >
          {({
            values,
            handleChange,
            handleBlur,
            touched,
            errors,
            handleSubmit,
            setFieldValue,
            isSubmitting
          }) => (
            <Form>
              {/* <div className="col-md-12">
              <div className="form-group align-items-center">
                <label className="form-label">Add Existing User</label>
                <div className="custom-switch-main">
                  <Input type="checkbox" id="switch" onChange={(e) => setToggleChecked(e.target.checked)} /><label htmlFor="switch">Toggle</label>
                </div>
              </div>
            </div> */}
              {/* {console.log(toggleChecked)} */}
              {/* {!toggleChecked && ( */}
              <div className="col-md-12">
                <div className="form-group">
                  <div className="form-group">
                    <label className="form-label">First Name</label>
                    <Fields
                      type="text"
                      placeholder="Add Name"
                      className="form-control"
                      touched={touched}
                      errors={errors}
                      onBlur={handleBlur}
                      name="first_name"
                      value={values.first_name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <div className="form-group">
                    <label className="form-label">Last Name</label>
                    <Fields
                      type="text"
                      placeholder="Add Name"
                      className="form-control"
                      touched={touched}
                      errors={errors}
                      onBlur={handleBlur}
                      name="last_name"
                      value={values.last_name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              {/* )} */}
              <div className="col-md-12">
                <div className="form-group">
                  <div className="form-group">
                    <label className="form-label">Email</label>
                    <Fields
                      type="email"
                      placeholder="Add Email"
                      className="form-control"
                      touched={touched}
                      errors={errors}
                      onBlur={handleBlur}
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <label className="form-label">User Role</label>
                  <div className="form-group">
                    {/* {userRoleOptions[0] && */}
                    <Select
                      id="inputGroupSelect01"
                      name="userRole"
                      value={userRoleOptions?.value}
                      onChange={(value) =>
                        setFieldValue("userRole", value?.value)
                      }
                      options={userRoleOptions}
                      classNamePrefix="cmn-control"
                    /* defaultValue={userRoleOptions[0]} */
                    />
                    {/* } */}
                    <ErrorMessage
                      name="userRole"
                      component={({ children }) => (
                        <div className="text-start text-danger mb-0">
                          {children}
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
              {/* {!toggleChecked && ( */}
              {/* <div className="col-md-12">
              <div className="form-group">
                <div className="form-group">
                  <label className="form-label">Department</label>
                  <Fields
                    type="text"
                    placeholder="Add Department"
                    className="form-control"
                    touched={touched}
                    errors={errors}
                    onBlur={handleBlur}
                    name="department"
                    value={values.department}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div> */}
              {/* )} */}
              {/* {!toggleChecked && ( */}
              <div className="col-md-12">
                <div className="form-group">
                  <div className="form-group">
                    <label className="form-label">Mobile </label>
                    <PhoneInput
                      // onKeyDown={(e) => console.log(e.keyCode)}
                      country={code ? code : "us"}
                      name="mobile"
                      id="mobile"
                      searchPlaceholder="Search country"
                      disableInitialCountryGuess={false}
                      enableLongNumbers={true}
                      countryCodeEditable={false}
                      onChange={mobileNumberHandler}
                      value={codeMobile}
                      enableSearch={true}
                    />
                    <span className="hint">
                      <div className="mt-0 mx-0">
                        <div className="text-start text-danger mb-2 mt-2">
                          {mobileError}
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <label className="form-label">Projects</label>
                  <div className="form-group">
                    <Select
                      id="inputGroupSelect02"
                      name="project"
                      value={values?.project}
                      onChange={(value) => setFieldValue("project", value)}
                      options={userProjectOptions}
                      closeMenuOnSelect={false}
                      isMulti={true}
                      classNamePrefix="cmn-control"
                    />
                    <ErrorMessage
                      name="project"
                      component={({ children }) => (
                        <div className="text-start text-danger mb-0">
                          {children}
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
              {/* )} */}
              <div className="text-start text-md-end add-user-modal-footer">
                <button
                  type="button"
                  className="btn btn-primary-md"
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                >
                  Save
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default AddUserForm;
